// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__XjoLP","actions":"styles_actions__4DmNi","content":"styles_content__7ebxp","description":"styles_description__Z0ZUS"};